import React from 'react';
import { Link } from 'react-router-dom';

interface TitleDisplayProps {
  title?: string;
  linkText?: string;
  linkTo?: string;
  unlockHeader?: string;
}

const TitleDisplay: React.FC<TitleDisplayProps> = ({ title, linkText, linkTo, unlockHeader }) => {
  return (
    <>
      {unlockHeader == null && (
        <div className="title">
          <h1 dangerouslySetInnerHTML={{ __html: title ||' '}} />
        </div>
      )}
      {linkText && linkTo && (
        <div className="userAccessOption pull-right">
          <Link
            to={linkTo}
            style={unlockHeader === "true" ? { color: "#1794ef" } : {}}
          >
            {linkText}
          </Link>
        </div>
      )}
    </>
  );
};

export default TitleDisplay; 